import React, { useState } from 'react';
import './ProductsOverview.css';

const ProductsOverview = () => {
  const categories = [
    {
      title: 'Bulk Groceries',
      text: 'Rice, pasta, and more – stock up for less.',
      image: 'https://www.lakewinds.coop/wp-content/uploads/2016/09/groceries-cropped-1024x680.jpg',
      deal: '15% Off 10+ Units',
    },
    {
      title: 'Beverages',
      text: 'Cola, energy drinks, tea – cases that sell.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWWk1B_9WuNHQV9_aRLuUt29DPSu1XoxHvoQ&s',
      deal: '20% Off Pallets',
    },
    {
      title: 'Household',
      text: 'Ocado wipes, bleach, bags – bulk essentials.',
      image: 'https://m.media-amazon.com/images/I/61-3uNXIfsL._AC_SX679_.jpg',
      deal: 'Buy 5, Get 1 Free',
    },
    {
      title: 'Snacks',
      text: 'Crisps, chocolates – crates for quick sales.',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSuMcWzobuLu-GUoYUyDsts8Z7IQTv6D2GQCQ&s',
      deal: '3-for-2 Deals',
    },
    {
      title: 'Personal Care',
      text: 'Soap, shampoo – wholesale hygiene.',
      image: 'https://m.media-amazon.com/images/I/51Ku4FMdpdL._AC_UL480_FMwebp_QL65_.jpg',
      deal: '25% Off Bulk',
    },
    {
      title: 'Frozen',
      text: 'Chips, pizzas – frozen profits.',
      image: 'https://dmrqkbkq8el9i.cloudfront.net/Pictures/480xany/0/1/3/278013_poundlandchilledandfrozen2medres_708533.jpg',
      deal: '20% Off 10+ Packs',
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? categories.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === categories.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="products" className="products-overview">
      <div className="products-container">
        <h2 className="products-title">Nand's Wholesale Collection</h2>
        <div className="products-carousel">
          <button
            className="carousel-control prev"
            onClick={handlePrev}
            aria-label="Previous category"
          >
            <span className="control-icon">←</span>
          </button>
          <div className="carousel-track">
            {categories.map((category, index) => (
              <div
                key={category.title}
                className={`carousel-item ${
                  index === activeIndex ? 'active' : ''
                }`}
              >
                {category.video && index === activeIndex ? (
                  <video
                    src={category.video}
                    autoPlay
                    loop
                    muted
                    className="item-media"
                  />
                ) : (
                  <img
                    src={category.image}
                    alt={category.title}
                    className="item-media"
                  />
                )}
                <div className="item-content">
                  <h3 className="item-title">{category.title}</h3>
                  <p className="item-text">{category.text}</p>
                  <span className="item-deal">{category.deal}</span>
                  <a
                    href={`#${category.title.toLowerCase().replace(' ', '-')}`}
                    className="item-cta"
                  >
                    Shop Now
                  </a>
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control next"
            onClick={handleNext}
            aria-label="Next category"
          >
            <span className="control-icon">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductsOverview;